import { attr } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

/**
 * An event created when Patient administrative data are updated.
 * The event keeps track of changes at the time of recording.
 */
export default class PatientAdministrativeDataUpdatedJournalEvent extends JournalEvent {
  static override type = "patient-administrative-data-updated-journal-event";

  /**
   * A key-value object representing changes to the patient.
   * The key is a patient attribute, the value is the entered value.
   *
   * For instance:
   *
   * ```js
   * {
   *   "firtName": "Jane",
   *   "lastName": "Doe"
   * }
   * ```
   *
   * A removed attribute is actually never removed but replaced by
   * an empty string, meaning we would have this changes:
   *
   * ```js
   * {
   *   "city": ""
   * }
   * ```
   */
  @attr() declare informationChanges: any;

  static override validations(intl: IntlService) {
    return {
      informationChanges: validatePresence({
        presence: true,
        description: intl.t(
          "validations.patient-administrative-data-updated-journal-event.information-changes"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.patient-administrative-data-updated-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "patient-administrative-data-updated-journal-event": PatientAdministrativeDataUpdatedJournalEvent;
  }
}
